import axios from "axios";
import * as d3 from "d3";
import {colonAnnotation, fw_progressive_1way} from '../functions'

export default function (chart, divId, vizName) {
    var url = '/api/fetchData/' + chart.data.syspk + '/' + vizName

    console.log("Chart vizName called:", vizName)

    function bubbleChart() {
        var svg = d3.select(divId).select("svg").remove();
        svg = d3.select(divId)
            .append('svg')
            .attr('width', chart.width - chart.margin.left + chart.margin.right)
            .attr('height', chart.height + chart.margin.top + chart.margin.bottom)
            .append('g')
            .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')')

        function chart1(selection) {
            var data = selection.datum()
            svg = selection.selectAll('svg')
            svg.attr('width', chart.width - 300).attr('height', chart.height - 300)

            svg.append('text')
                .attr('x', (chart.width / 4))
                .attr('y', (chart.margin.top / 5))
                .attr('text-anchor', 'middle')
                .style('font-size', '20px')
                .text(chart.x1AxisDisplayName)

            var y1tip = selection
                .style('line-height', '1')
                .style('padding', '12px')
                .style('background', 'white')
                .style('border-radius', '5px')
                .style('position', 'absolute')
                .style('border-width', '.1px')
                .style('border-style', 'groove')

            var metric1ColorScale = d3.scaleOrdinal().range(fw_progressive_1way)

            var minRadiusDomain = d3.min(data, function (d) {
                return +d[chart.y1AxisDisplayName]
            })
            var maxRadiusDomain = d3.max(data, function (d) {
                return +d[chart.y1AxisDisplayName]
            })
            var scaleRadius = d3.scaleLinear()
                .domain([minRadiusDomain, maxRadiusDomain])
                .range([chart.vizSpecific1, chart.vizSpecific2])

            var node = svg.selectAll('circle')
                .data(data)
                .enter()
                .append('g')
                .attr('transform', 'translate(' + [chart.width / 2, chart.height / 2] + ')')
                .style('opacity', 1)

            node.append('circle')
                .attr('id', function (d, i) {
                    return i
                })
                .attr('r', function (d) {
                    return scaleRadius(d[chart.y1AxisDisplayName])
                })
                .style('fill', function (d) {
                    return metric1ColorScale(d['dim1'])
                })
                .on('mouseover', function (d) {
                    y1tip.html(chart.titleToolTip + colonAnnotation + d['dim1'] + '<br/>'
                        + chart.y1MetricTooltip + colonAnnotation + d['dim2'] + '<br/>'
                        + chart.y2MetricTooltip + colonAnnotation + d[chart.y1AxisDisplayName] + ' ' + chart.unit)
                    return y1tip.style('visibility', 'visible')
                })
                .on('mousemove', function () {
                    return y1tip.style('top', '100px').style('left', (chart.width - 430) + 'px')
                })
                .on('mouseout', function () {
                    return y1tip.style('visibility', 'hidden')
                })
            //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding
        }

        chart1.width = chartWidth
        chart1.height = chartHeight
        chart1.dim1 = chartColForColors
        chart1.y1AxisDisplayName = chartColForRadius
        chart1.dim2 = chartColForTitle
        chart1.vizSpecific1 = chartMinRadius
        chart1.vizSpecific2 = chartMaxRadius
        chart1.vizSpecific3 = chartForceApart
        chart1.metricUnit = chartUnitName

        function chartWidth(value) {
            if (!arguments.length) {
                return chart.width
            }
            chart.width = value
            return chart1
        }

        function chartHeight(value) {
            if (!arguments.length) {
                return chart.height
            }
            chart.height = value
            chart.margin.top = 80
            return chart1
        }

        function chartColForColors(value) {
            if (!arguments.length) {
                return dim1
            }
            let dim1;
            dim1 = value
            return chart1
        }

        function chartColForTitle(value) {
            if (!arguments.length) {
                return dim2
            }
            let dim2;
            dim2 = value
            return chart1
        }

        function chartColForRadius(value) {
            if (!arguments.length) {
                return chart.y1AxisDisplayName
            }
            chart.y1AxisDisplayName = value
            return chart1
        }

        function chartMinRadius(value) {
            if (!arguments.length) {
                return chart.vizSpecific1
            }
            chart.vizSpecific1 = value
            return chart1
        }

        function chartMaxRadius(value) {
            if (!arguments.length) {
                return chart.vizSpecific2
            }
            chart.vizSpecific2 = value
            return chart1
        }

        function chartUnitName(value) {
            if (!arguments.length) {
                return chart.metricUnit
            }
            chart.metricUnit = value
            return chart1
        }

        function chartForceApart(value) {
            if (!arguments.length) {
                return chart.vizSpecific3
            }
            chart.vizSpecific3 = value
            return chart1
        }

        return chart1
    }

    axios.get(url).then(res => {
        let data = res.data;
        var chart1 = bubbleChart().width(chart.width).height(chart.height)
        d3.select(divId).datum(data).call(chart1)
    })
}
